import sv from "./sv";
import no from "./no";
import dk from "./dk";

export default {
    sv,
    no,
    dk
};